export const authProviderCookieName = 'le_admin_auth_provider';

export type AuthProvider = 'legacy' | 'v2';

const authProviderValues = new Set<AuthProvider>(['legacy', 'v2']);

function getCookieAttributes(maxAge: number) {
  const attributes = [`Path=/`, `Max-Age=${maxAge}`, 'SameSite=Lax'];

  if (window.location.protocol === 'https:') {
    attributes.push('Secure');
  }

  return attributes.join('; ');
}

function parseAuthProvider(value: string | null | undefined): AuthProvider | null {
  if (!value || !authProviderValues.has(value as AuthProvider)) {
    return null;
  }

  return value as AuthProvider;
}

export function isAuthV2Enabled() {
  return window.configs.AUTH_V2 === 'true';
}

export function getStoredAuthProvider(): AuthProvider | null {
  const cookies = document.cookie ? document.cookie.split(';') : [];

  for (const cookie of cookies) {
    const [rawName, ...rest] = cookie.split('=');

    if (rawName.trim() !== authProviderCookieName) {
      continue;
    }

    return parseAuthProvider(decodeURIComponent(rest.join('=').trim()));
  }

  return null;
}

export function resolveAuthProvider(): AuthProvider {
  const storedProvider = getStoredAuthProvider();

  if (storedProvider === 'v2' && !isAuthV2Enabled()) {
    return 'legacy';
  }

  return storedProvider ?? 'legacy';
}

export function rememberAuthProvider(provider: AuthProvider) {
  document.cookie = `${authProviderCookieName}=${encodeURIComponent(provider)}; ${getCookieAttributes(
    60 * 60 * 24 * 30,
  )}`;
}

export function clearAuthProvider() {
  document.cookie = `${authProviderCookieName}=; ${getCookieAttributes(0)}`;
}
